import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import DashboardLayout, { DashboardTab } from "layouts/Dashboard";
import { Button, Typography } from "@material-ui/core";
import { PromiseContainer } from "util/promises";
import { logPageView } from "services/analytics";
import RouteURLs from "RouteURLs";
import "./index.scss";
import { User } from "services/entities/auth";
import { loadUser } from "services/auth";
import BookingsSection from "./components/BookingsSection";
import DesignsSection from "pages/Dashboard/components/DesignsSection";

interface DashboardPageState {
  user: User | null;
}

export default class DashboardPage extends Component<
  RouteComponentProps,
  DashboardPageState
> {
  private promiseContainer: PromiseContainer | null = null;

  state: DashboardPageState = {
    user: null,
  };

  componentDidMount(): void {
    logPageView(RouteURLs.DASHBOARD, "Dashboard");
    this.promiseContainer = new PromiseContainer();
    this.loadUser(this.promiseContainer);
  }

  componentWillUnmount(): void {
    if (this.promiseContainer) {
      this.promiseContainer.dispose();
      this.promiseContainer = null;
    }
  }

  render() {
    const user: User | null = this.state.user;
    return (
      <DashboardLayout id="dashboard-page" currentTab={DashboardTab.Overview}>
        <section className="summary">
          <Typography variant="h2" component="h2">
            Welcome back{user && user!.firstName ? `, ${user!.firstName}` : ""}
          </Typography>
          <Button
            className="new-design"
            variant="contained"
            onClick={this.onNewDesignClick}
          >
            Create a new design
          </Button>
          <span className="subtitle">What can we help with?</span>
        </section>
        <BookingsSection />
        <DesignsSection />
      </DashboardLayout>
    );
  }

  loadUser(promiseContainer: PromiseContainer) {
    promiseContainer
      .add(loadUser())
      .then((user) => this.setState({ user: user }));
  }

  onNewDesignClick = () => {
    this.props.history.push(RouteURLs.NEW_DESIGN);
  };
}
